import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { TokenService } from 'src/app/core/token/token.service';
import { IntegrationService } from 'src/app/services/integration.service';
import Editor from "src/assets/ckeditor5-41.3.0/build/ckeditor";
import { StripHtmlPipe } from 'src/app/shared/validators/pipes/stripHtml.pipe';
import { TarefaService } from 'src/app/services/tarefa.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { environment } from 'src/environments/environment';
import swal from "sweetalert2";
declare let moment: any;

@Component({
  selector: 'app-modal-reagendamento',
  templateUrl: './modal-reagendamento.component.html',
  styleUrls: ['./modal-reagendamento.component.scss']
})
export class ModalReagendamentoComponent implements OnInit, OnDestroy {
  rescheduleForm: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl("", Validators.required),
  });
  @Input() tarefa;
  @Input() esconde_selects;
  tecnico: any;
  hoje = new Date();
  selector: string;
  newSubs: Subscription;
  integracao_google: boolean = false;
  integracao_outlook: boolean = false;
  public Editor = Editor;
  public editorConfig: any;
  descricao: any;

  constructor(
    private tarefaService: TarefaService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private elemRef: ElementRef,
    private usuarioService: UsuariosService,
    private tokenService: TokenService,
    private integrationService: IntegrationService,
    private stripHtmlPipe: StripHtmlPipe
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.rescheduleForm.patchValue({
      description: this.tarefa.descricao_html
    });
    this.getTarefa();
    this.setEditorConfig();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  setEditorConfig(): void {
    this.editorConfig = {
      image: {
        resizeUnit: 'px',
        resizeOptions: [
          { name: 'resizeImage:original', label: 'Original', value: null },
          { name: 'resizeImage:100', label: '100px', value: '100' },
          { name: 'resizeImage:200', label: '200px', value: '200' }
        ]
      },
      placeholder: this.translate.instant('INSIRA_TEXTO_IMAGEM')
    };
  }

  private editorHtml(formName: string): string {
    return this.rescheduleForm.get(formName)?.value ?? '';
  }

  private editorTexto(formName: string): string {
    return this.stripHtmlPipe.transform(this.editorHtml(formName));
  }

  checkFields(formName: string): boolean {
    const html = this.editorHtml(formName);
    const cleanText = this.editorTexto(formName).replaceAll('\n', '');
    const hasImage = /<img/.test(html);
    return (cleanText.length <= 5 && !hasImage);
  }

  close(result?) {
    this.activeModal.close(result);
  }

  changeTecnico(tecnico) {
    this.tecnico = tecnico;
    this.hasChangeOperator = true;
    this.setInteracaoGoogleAgenda();
  }

  hasChangeOperator = false;

  setInteracaoGoogleAgenda(): void {
    let param = {
      userId: this.tecnico.id
    }
    this.newSubs = this.integrationService.validAuthTecnicoGoogle(param).subscribe(
      {
        next: (result) => {
          if (result && result.hasOwnProperty('active')) {
            this.integracao_google = result.active;
            if (!this.integracao_google) {
              this.validAuthTecnicoOutlook();
            } else {
              this.integracao_outlook = false;
              this.hasChangeOperator = false;
            }
          } else {
            this.hasChangeOperator = false;
          }

        }, error: (error) => console.error('setIntegracaoGoogleAgenda', error)
      }
    )
  }

  validAuthTecnicoOutlook(): void {
    let param = {
      userId: this.tecnico.id
    }
    this.newSubs = this.integrationService.validAuthTecnicoOutlook(param).subscribe(
      {
        next: (result) => {
          if (result && result.hasOwnProperty('active')) {
            this.integracao_outlook = result.active;
          }
          this.hasChangeOperator = false;
        }, error: (error) => console.error('validAuthTecnicoOutlook', error)
      }
    )
  }

  updateDescricao(event) {
    this.tarefa.descricao = event;
  }

  calculateFinalMeet(date, tempo_tarefa): string {
    if (date) {
      return moment(date).add(moment.duration(tempo_tarefa)).format("YYYY-MM-DD HH:mm:ss");
    }
  }

  setEventGoogleSchedule(payload: any, tarefa: any): void {
    payload['data_agendamento_google_inicial'] = moment(tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss");
    payload['data_agendamento_google_final'] = moment(this.calculateFinalMeet(tarefa.data_agendamento, tarefa.tempo_tarefa)).format("YYYY-MM-DDTHH:mm:ss");
    payload['local'] = tarefa.local ? tarefa.local : '';
    payload['convidados'] = tarefa.convidados === '' ? [] : tarefa.convidados;
    payload['google_meet'] = tarefa.google_meet;
  }

  setEventOutlookCalendar(payload: any, tarefa: any): void {
    payload['data_agendamento_outlook_inicial'] = moment(tarefa.data_agendamento).format("YYYY-MM-DDTHH:mm:ss");
    payload['data_agendamento_outlook_final'] = moment(this.calculateFinalMeet(tarefa.data_agendamento, tarefa.tempo_tarefa)).format("YYYY-MM-DDTHH:mm:ss");
    payload['local'] = tarefa.local ? tarefa.local : '';
    payload['convidados'] = tarefa.convidados === '' ? [] : tarefa.convidados;
    payload['outlook_teams'] = tarefa.teams_link;
  }

  salvar() {
    var _obj = {
      tarefa_id: this.tarefa.tarefa_id,
      tecnico_id: this.tecnico.id,
      tempo_tarefa: this.tarefa.tempo_tarefa,
      descricao: this.editorTexto('description'),
      descricao_html: this.editorHtml('description'),
      data_agendamento: this.tokenService.convertDateTimezoneStockFormat(this.tarefa.data_agendamento),
      titulo: this.tarefa.titulo,
      integracao_google: this.integracao_google.toString(),
      tipo_tarefa_id: this.tarefa.tipo_tarefa_id && this.tarefa.tipo_tarefa_id.id ? this.tarefa.tipo_tarefa_id.id : null,
      integracao_outlook: this.integracao_outlook.toString(),

    };

    if (this.tarefa.cliente_id && this.tarefa.cliente_id.id) {
      _obj['cliente_id'] = this.tarefa.cliente_id.id;
    }
    if (this.tarefa.chamado_id && this.tarefa.chamado_id.id) {
      _obj['chamado_id'] = this.tarefa.chamado_id.id;
    }

    if (this.integracao_google) {
      this.setEventGoogleSchedule(_obj, this.tarefa);
    } else if (this.integracao_outlook) {
      this.setEventOutlookCalendar(_obj, this.tarefa);
    }

    if (this.tarefa.integracao_google === 'false' && this.tarefa.integracao_outlook === 'false') {
      _obj.data_agendamento = this.tokenService.convertDateTimezoneStockFormat(this.tarefa.data_agendamento);
      delete _obj['convidados'];
    }

    if (this.checkOperador()) {
      this.newSubs = this.tarefaService.reagendarTarefa(_obj)
        .subscribe(results => {
          this.toastr.show(this.translate.instant('REAGENDADO_SUCESSO'), '', environment.toastrConfig('success'));
          this.close(_obj);
        }, error => {
          this.checkError(error);
        });
    } else {
      swal.fire({
        text: this.translate.instant('AVISO_REAGENDAMENTO_INTEGRACAO'),
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK',
      })
    }
  }

  checkOperador(): boolean {
    if (this.tarefa?.integracao_google.toString() === "true" && this.integracao_google.toString() === "true") {
      return true;
    } else if (this.tarefa?.integracao_outlook.toString() === "true" && this.integracao_outlook.toString() === "true") {
      return true;
    } else if (this.integracao_google.toString() === "false" && this.integracao_outlook.toString() === "false") {
      return true;
    } else if (this.tarefa?.integracao_google.toString() === "false" && this.tarefa?.integracao_outlook.toString() === "false") {
      return true;
    }
    return false;
  }

  checkError(error) {
    if (error && error.code === "FORBIDDEN" && error.details === "credentials not found" && error.status === 403) {
      this.toastr.show(this.translate.instant('ERRO_REAGENDAR_INTEGRACAO_GOOOGLE_AGENDA'), '', environment.toastrConfig('warning'));
    }
  }

  checkKindGoogle(kind): boolean {
    return kind && kind.includes('calendar#event');
  }

  checkKindOutlook(kind): boolean {
    return kind && kind.includes('outlook#calendar');
  }

  getTarefa() {
    this.newSubs = this.tarefaService.getTarefaById(this.tarefa.tarefa_id).subscribe(
      (result) => {
        /* this.integracao_google = this.checkKindGoogle(result.tarefa.kind);
        this.integracao_outlook = this.checkKindOutlook(result.tarefa.kind); */
        this.tarefa.integracao_google = result.tarefa.id_google_agenda ? true : false;
        this.tarefa.integracao_outlook = result.tarefa.id_outlook_agenda ? true : false;
        this.getOperadortecnicoId(result.tarefa.tecnico_id);
      }, (error) => console.error('getTarefa', error)
    )
  }

  verifica() {
    return (!this.tarefa.data_agendamento) ||
      (!this.tecnico || !this.tecnico.id)
  }

  getOperadortecnicoId(tecnicoId) {
    this.newSubs = this.usuarioService.getUsuarioById(tecnicoId).subscribe(
      (results) => {
        this.tecnico = results.usuario;
        this.setInteracaoGoogleAgenda();
      }, (error) => console.error('getOperadortecnicoId', error)
    );
  }
}